export const root = '/account-setup';
